module.exports = __webpack_public_path__ + "static/media/step-2.ef963eee.png";